module.exports = __webpack_public_path__ + "images/3e8eb91c2c5f32c7edccecf1c965f293-illu_dir_recessed1.png";